import { AlertResponse, IAssetMaintenanceSchedule, IqueryParams } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

interface ExportMaintenanceParams extends IqueryParams<{
  asset_category?: string;
  asset_serial_number?: string;
  schedule_status?: string;
  search?: string;
}> {
  file_format: 'pdf' | 'csv';
}

const createAssetMaintenanceSchedule = async (
  data: IAssetMaintenanceSchedule
) => {
  return apiService.apiRequest<{ name: string }>(
    "post",
    `asset-maintenance-schedules`,
    data
  );
};

const getAssetMaintenanceSchedules = async (queryParams?:IqueryParams< {
  district_name?: string;
  region_name?: string;
}>) => {
  const query = buildQueryString(queryParams);
  return apiService.apiRequest<any>(
    "get",
    `asset-maintenance-schedules${query}`
  );
};

const getAssetMaintenanceSchedule = async (schedule_id: string) => {
  return apiService.apiRequest<any>(
    "get",
    `asset-maintenance-schedules/${schedule_id}/`
  );
};

const updateAssetMaintenanceSchedule = async (
  schedule_id: string,
  data: IAssetMaintenanceSchedule
) => {
  return apiService.apiRequest<any>(
    "put",
    `asset-maintenance-schedules/${schedule_id}`,
    data
  );
};

const deleteAssetMaintenanceSchedule = async (schedule_id: string) => {
  return apiService.apiRequest<any>(
    "delete",
    `asset-maintenance-schedules/${schedule_id}`
  );
};

const restoreAssetMaintenanceSchedule = async (schedule_id: string) => {
  return apiService.apiRequest<any>(
    "get",
    `asset-maintenance-schedules/${schedule_id}/restore`
  );
};

const exportAssetMaintenanceSchedules = async (params: ExportMaintenanceParams) => {
  const { page, page_size, ...exportParams } = params;
  const query = buildQueryString(exportParams);

  return apiService.apiRequest<{ download_url: string }>(
    "get",
    `asset-maintenance-schedules/export${query}`
  );
};




export const AssetMaintenanceApi = {
  createAssetMaintenanceSchedule,
  getAssetMaintenanceSchedules,
  getAssetMaintenanceSchedule,
  updateAssetMaintenanceSchedule,
  deleteAssetMaintenanceSchedule,
  restoreAssetMaintenanceSchedule,
  exportAssetMaintenanceSchedules,
};